<template>
    <div id="offer-list">

        <div class="hidden-sm-and-up mt-1">
            <CreditScoreLinear></CreditScoreLinear>
        </div>

        <v-container>
            <v-row>
                <v-col cols="12">
                    <div class="display-1">
                        {{$t('my_offers')}}
                        <v-chip color="error" label>NEW</v-chip>
                    </div>
                    <div class="title text--thin">{{$t('best_offers_for_you')}}</div>
                </v-col>
                <v-col cols="12" align="center">
                    <div class="title font-weight-bold">{{$t('we_recommend_to_use_all_offers')}}
                    </div>
                </v-col>
            </v-row>
            <v-row tag="v-container" no-gutters v-if="isSuccess">
                <v-col cols="12" v-if="offers_top">
                    <v-row v-bind:key="offer.id" v-for="(offer, index) in offers_top">
                        <v-col v-if="(Math.floor(offers_top.length / 2) == index) && ads_offers_settings.placement == 'middle' && enable_ads_offers" cols="12">
                            <Adsense :settings="ads_offers_settings"></Adsense>
                        </v-col>
                        <v-col cols="12">
                            <Offer :offer="offer" is_clickable="true" :id="offer.id"
                                   v-intersect.once="onIntersect">
                            </Offer>
                        </v-col>
                        <v-col v-if="(index == 0) && enable_second_ads_offers" cols="12">
                            <Adsense :settings="second_ads_offers_settings"></Adsense>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row tag="v-container" no-gutters v-if="isSuccess">
                <v-col cols="12" v-if="offers_top">
                    <v-hover>
                        <template v-slot:default="{ hover }" open-delay="0">
                            <div>
                                <v-row v-bind:key="offer.id" v-for="(offer) in offers_down">
                                    <v-col cols="12">
                                        <Offer :offer="offer" :id="offer.id"
                                               v-intersect.once="onIntersect">
                                        </Offer>
                                    </v-col>
                                </v-row>
                                <v-fade-transition>
                                    <v-overlay
                                        v-if="hover"
                                        absolute
                                        opacity="0.8"
                                        color="#000000"
                                        class="offer-overlay"
                                    >
                                        <v-row align="start">
                                            <v-col cols="12" align="center"
                                                   class="headline text--thin overlay-headline">
                                                {{$t('get_more_offers_verificate_your_email')}}
                                            </v-col>
                                            <v-col cols="12" align="center">
                                                <v-btn x-large outlined @click="pushToProfile()">
                                                    {{$t('go_to_profile')}}
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-overlay>
                                </v-fade-transition>
                            </div>
                        </template>
                    </v-hover>
                </v-col>
            </v-row>
            <div v-if="enable_ads_offers && ads_offers_settings.placement == 'bottom'">
                <Adsense :settings="ads_offers_settings"></Adsense>
            </div>
        </v-container>
        <v-speed-dial top right class="hidden-xs-only">
            <template v-slot:activator>
                <div class="offers-floating" @click="pushToProfile()">
                    <CreditScoreChart :score="user.credit_score" height="150px" width="130px" size="x-small"></CreditScoreChart>
                </div>
            </template>
        </v-speed-dial>
    </div>
</template>

<script>
    import StarRating from 'vue-star-rating';
    import Offer from "@/app/client/offers/shared/components/offer";
    import CreditScoreChart from "@/app/client/profile/shared/components/creditScoreChart";
    import CreditScoreLinear from "@/app/client/profile/shared/components/creditScoreLinear";
    import settings from "@/environment";

    import Adsense from "@/app/shared/components/app-ads/Adsense";

    export default {
        name: 'Offers',
        components: {
            StarRating,
            Offer,
            CreditScoreChart,
            CreditScoreLinear,
            Adsense
        },
        data() {
            return {
                hover: false,
                price: null,
                days: null,
                overlay: false,
                showed_offers: [],
                current_user: null,
                source: sessionStorage.getItem('source'),
                enable_ads_offers: settings.enable_ads_offers,
                ads_offers_settings: settings.ads_offers_settings,
                enable_second_ads_offers: settings.enable_second_ads_offers,
                second_ads_offers_settings: settings.second_ads_offers_settings,
            };
        },
        computed: {
            isLoading() {
                return this.$store.getters.CLIENT_OFFERS_IS_LOADING;
            },
            isSuccess() {
                return this.$store.getters.CLIENT_OFFERS_LOADING_SUCCESS;
            },
            isRegistered() {
                return this.$store.getters.IS_REGISTERED;
            },
            user() {
                return this.$store.getters.AUTH_USER;
            },
            offers_top() {
                const show_all_offers = settings.is_mailgun_ok ? this.user.is_email_confirm : true;
                return this.$store.getters.CALCULATE_PRICE_TOP(this.$data.price, this.$data.days, show_all_offers, this.source);
            },
            offers_down() {
                const show_all_offers = settings.is_mailgun_ok ? this.user.is_email_confirm : true;
                return this.$store.getters.CALCULATE_PRICE_DOWN(show_all_offers, this.source);
            },
            min_days() {
                return this.$store.getters.MIN_DAYS;
            },
            max_days() {
                return this.$store.getters.MAX_DAYS;
            },
            min_sum() {
                return this.$store.getters.MIN_SUM;
            },
            max_sum() {
                return this.$store.getters.MAX_SUM;
            },
        },
        created() {
            this.current_user = this.user;
            window.addEventListener('beforeunload', this.sendShowcaseViews);
            this.$store.dispatch('GET_CLIENT_OFFERS').finally(() => {
                this.price = this.min_sum;
                this.days = this.min_days;
            });
            if (this.$route.query.source) {
                sessionStorage.setItem('source', this.$route.query.source);
            }
            if (this.current_user.vkid != null) {
                sessionStorage.setItem('vkid', this.current_user.vkid);
            }
            if (this.current_user.pxlid != null) {
                sessionStorage.setItem('pxlid', this.current_user.pxlid);
            }
            if (this.isRegistered) {
                this.$store.dispatch("SET_REGISTERED", false);
                sessionStorage.setItem('is_registered', '1');
            }
        },
        methods: {
            openOffer(url, offer) {
                let chosen_offer = {
                    offer: offer.id,
                    sum: this.price,
                    days: this.days,
                    aff_sub3: offer.lead_uuid,
                    pattern_id: offer.pattern_id
                };
                this.$store.dispatch('CHOSE_OFFER', chosen_offer);

                if ((sessionStorage.getItem('source') != '') && (sessionStorage.getItem('source') != null)) {
                    var re = new RegExp("\A?aff_sub4=[^&]+", "i");
                    if (url.match(re)) {
                        url = url.replace(re, "aff_sub4=" + sessionStorage.getItem('source'));
                    } else {
                        re = new RegExp("\A?s4=[^&]+", "i");
                        if (url.match(re)) {
                            url = url.replace(re, "s4=" + sessionStorage.getItem('source'));
                        }
                    }
                }
                window.open(url, '_blank');
            },
            pushToProfile() {
                this.$router.push('/panel/profile');
            },
            onIntersect(entries, observer) {
                if (entries[0].isIntersecting) {
                    this.showed_offers.push(entries[0].target.id);
                }
            },
            sendShowcaseViews() {
                let params = {
                    offer_id: this.showed_offers,
                    profile_id: this.current_user.id
                };
                if ((this.showed_offers !== []) && (this.showed_offers != null)) {
                    this.$store.dispatch('SEND_SHOWCASE_VIEWS', params);
                    this.showed_offers = [];
                }
            },
        },
        beforeDestroy() {
            this.sendShowcaseViews()
        }
    };
</script>

<style>
    .offer-overlay .v-overlay__content {
        position: absolute !important;
        top: 50px !important;
    }

    .offer-overlay .v-overlay__scrim {
        border-radius: 5px;
    }

    #offer-list .v-speed-dial {
        position: absolute;
    }

    #offer-list .offer-floating {
        position: relative;
        cursor: pointer;
    }

    .offers-floating {
        cursor: pointer;
    }

</style>
